
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/mon-compte",
      function () {
        return require("private-next-pages/mon-compte/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/mon-compte"])
      });
    }
  